<template>
  <div class="order-page">
    <van-nav-bar fixed placeholder class="page-nav" :border="false" :title="$t('grab.record')">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
      <template #title>
        <span class="page-title">{{ $t('grab.record') }}</span>
      </template>
    </van-nav-bar>

    <van-tabs v-model="activeTab" class="order-tabs" @change="getList">
      <van-tab :title="$t('grab.tab_wait')" :name="1" />
      <van-tab :title="$t('grab.tab_freeze')" :name="2" />
      <van-tab :title="$t('grab.tab_done')" :name="3" />
    </van-tabs>

    <div class="order-list">
      <div v-if="loading" class="empty-box">
        <van-loading type="circular" color="#e6b98a" size="40px" />
      </div>

      <div v-else-if="!list.length" class="empty-box">
        <p class="empty-text">{{ $t('grab.empty') }}</p>
        <button class="go-grab" @click="$router.push('/Game')">{{ $t('grab.go_grab') }}</button>
      </div>

      <div v-for="item in list" :key="item.id" class="order-card">
        <div class="order-head">
          <span class="order-no">{{ $t('grab.order_no') }}: {{ item.id }}</span>
          <span class="order-time">{{ item.addtime }}</span>
        </div>

        <div class="order-body">
          <div class="goods-block">
            <img
              v-if="item.goods_pic"
              :src="item.goods_pic"
              class="goods-pic"
              alt=""
            >
            <div v-else class="goods-pic placeholder">
              <van-icon name="bag-o" />
            </div>
            <div class="goods-info">
              <div class="goods-name">{{ item.goods_name || '-' }}</div>
              <div class="goods-shop">{{ item.shop_name || '' }}</div>
            </div>
          </div>
          <div class="order-info">
            <div class="info-row">
              <span class="info-label">{{ $t('grab.amount') }}</span>
              <span class="info-value">{{ formatMoney(item.num) }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">{{ $t('grab.commission') }}</span>
              <span class="info-value highlight">{{ formatMoney(item.commission) }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">{{ $t('grab.expected') }}</span>
              <span class="info-value">{{ formatMoney(item.yuji) }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">{{ $t('grab.status') }}</span>
              <span class="info-value status-text">{{ statusText(item.status) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 3,
      list: [],
      loading: false
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    formatMoney(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num.toFixed(2) : '0.00';
    },
    statusText(status) {
      const map = {
        0: this.$t('grab.st_wait'),
        1: this.$t('grab.st_done'),
        2: this.$t('grab.st_cancel'),
        3: this.$t('grab.st_force_done'),
        4: this.$t('grab.st_force_cancel'),
        5: this.$t('grab.st_freeze')
      };
      return map[Number(status)] || '-';
    },
    getList() {
      this.loading = true;
      this.$http({
        method: 'get',
        data: { type: this.activeTab, page: 1, num: 50 },
        url: 'order_list'
      }).then((res) => {
        this.loading = false;
        if (res && res.code === 200) {
          this.list = Array.isArray(res.data) ? res.data : [];
        } else {
          this.list = [];
        }
      }).catch(() => {
        this.loading = false;
        this.list = [];
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.order-page {
  min-height: 100vh;
  padding-bottom: 100px;
  background: #1f1c1f;
  color: #fff;
}

.page-nav {
  min-height: 98px;
  background: #1c1c1e;
}

::v-deep .page-nav .van-nav-bar {
  background: #1c1c1e;
  box-shadow: none;
}

::v-deep .page-nav .van-nav-bar__content {
  height: 88px;
}

.page-title {
  color: #e6b98a;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.order-tabs {
  background: #17181d;
}

::v-deep .order-tabs .van-tabs__wrap {
  height: 96px;
}

::v-deep .order-tabs .van-tabs__nav {
  height: 96px;
  background: #17181d;
}

::v-deep .order-tabs .van-tab {
  color: rgba(255, 255, 255, 0.6);
  font-size: 28px;
  line-height: 96px;
  padding: 0 12px;
}

::v-deep .order-tabs .van-tab--active {
  color: #e6b98a;
  font-weight: 700;
}

::v-deep .order-tabs .van-tabs__line {
  bottom: 14px;
  width: 36px;
  height: 6px;
  border-radius: 3px;
  background: #e6b98a;
}

.order-list {
  padding: 16px 12px 0;
}

.empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}

.empty-text {
  color: rgba(255, 255, 255, 0.5);
  font-size: 24px;
}

.go-grab {
  margin-top: 20px;
  padding: 16px 44px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(180deg, #f7dfc2, #dfb07d);
  color: #5f3a13;
  font-size: 24px;
  font-weight: 700;
}

.order-card {
  margin-bottom: 18px;
  padding: 20px;
  border: 1px solid #766350;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(38, 38, 38, 0.96), rgba(30, 30, 30, 0.94));
}

.order-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(239, 199, 155, 0.12);
}

.order-no {
  color: rgba(247, 210, 171, 0.8);
  font-size: 18px;
}

.order-time {
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
}

.order-body {
  display: flex;
  gap: 16px;
  padding: 16px 0;
}

.goods-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 130px;
}

.goods-pic {
  width: 110px;
  height: 110px;
  border-radius: 12px;
  object-fit: cover;
  background: #222;
}

.goods-pic.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #efc79b;
  font-size: 44px;
}

.goods-info {
  margin-top: 8px;
  text-align: center;
}

.goods-name {
  color: #fff;
  font-size: 20px;
  word-break: break-all;
}

.goods-shop {
  color: rgba(255, 255, 255, 0.5);
  font-size: 16px;
}

.order-info {
  flex: 1;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.info-label {
  color: rgba(247, 210, 171, 0.7);
  font-size: 20px;
}

.info-value {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}

.info-value.highlight {
  color: #fcd300;
}

.status-text {
  color: #efc79b;
}
</style>
